/**
 * Единый конфиг планов подписки.
 * Должен соответствовать backend SUBSCRIPTION_PLANS (subscription.ts).
 */
export type PlanType = 'basic' | 'pro' | 'premium' | 'full2026';

export const SUBSCRIPTION_PLANS: Array<{
  type: PlanType;
  price: number;
  priceDisplay: string;
  interval: 'month' | 'year' | 'once';
  featured: boolean;
}> = [
  { type: 'basic', price: 20, priceDisplay: '20', interval: 'month', featured: false },
  { type: 'pro', price: 45, priceDisplay: '45', interval: 'month', featured: true },
  { type: 'premium', price: 380, priceDisplay: '380', interval: 'year', featured: false },
  { type: 'full2026', price: 14.9, priceDisplay: '14,90', interval: 'once', featured: false },
];

export const PLAN_TYPES: PlanType[] = SUBSCRIPTION_PLANS.map((p) => p.type);

export function isPlanType(value: string | null | undefined): value is PlanType {
  return !!value && PLAN_TYPES.includes(value as PlanType);
}
